<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-row class="image-item" type="flex" justify="space-between"
                    v-if="config[field.key] && config[field.key]['title']">
                <div class="link-name" v-text="config[field.key]['title']"></div>
                <el-button size="small" @click="removeService" class="del-btn">删除</el-button>
            </el-row>
            <el-button size="small" @click="openDialog" v-text="config[field.key] ? '更换服务' : '添加服务'"></el-button>
        </el-form-item>
        <el-dialog title="请选择服务" :visible.sync="dialog.visible" @close='closeDialog'>
            <item-list @close="closeDialog" :url="tableList.url" :searchField="tableList.searchField"
                          :priceField="tableList.priceField" :titleField="tableList.titleField"
                          :resultArrayName="tableList.resultArrayName" :idList="idList" @select="select"></item-list>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .link-name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        padding-right: 20px;
    }

    .del-btn {
        height: 40px;
        margin-bottom: 10px;
    }
</style>

<script>

  import Util from '@/js/util';
  import _ from 'lodash';

  export default {
    name: 'tms-type-service-sale',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        linkNameList: {},
        currentIndex: 0,
        activeName: 'normal',
        tableList: {
          url: 'wdzg/b/cms/service/list',
          searchField: 'title_like',
          priceField: 'price',
          titleField: 'title',
          resultArrayName: 'service_list'
        },
        idList: []
      }
    },

    computed: {},

    components: {},

    created() {
    },

    methods: {
      openDialog() {
        this.dialog.visible = true;
      },
      removeService() {
        this.config[this.field.key] = {};
      },
      handleUpload(src, index) {
        this.$set(this.config[this.field.key], image_url, src);
        this.config[this.field.key].image_url = src;
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(row) {
        this.dialog.visible = false;
        let item = _.cloneDeep(row);
        item.cms_url = '/cms/page/biz/service.html?id=' + item.id;
        item.price = Util.filterPriceToFen(item.price);
        this.$set(this.config, this.field.key, item);
      },
      unSelect(row, index) {
        this.config[this.field.key].splice(index, 1);
      }
    }
  }

</script>
